import BibleVerse from 'src/bible/BibleVerse';

export default class VerseHistory {

    private items: BibleVerse[] = [];
    private cursor = -1;

    constructor(initialVerse: BibleVerse) {
        this.addVerse(initialVerse);
    }

    public addVerse(verse: BibleVerse): void {
        let insertPosition = this.cursor + 1;

        // Remove any existing verse before adding it again in the correct place.
        for (let itemIndex = 0; itemIndex < this.items.length; itemIndex++) {
            if (this.items[itemIndex].getIndex() === verse.getIndex()) {
                this.items.splice(itemIndex, 1);
                if (itemIndex < insertPosition) {
                    insertPosition--;
                }
                break;
            }
        }

        this.items.splice(insertPosition, 0, verse);
        this.cursor = insertPosition;
    }

    public getAll(): BibleVerse[] {
        return this.items;
    }

    public getCurrent(): BibleVerse {
        return this.items[this.cursor];
    }

    public isCurrentPosition(position: number): boolean {
        return position === this.cursor;
    }

    public goTo(position: number): void {
        this.cursor = Math.max(0, Math.min(this.items.length - 1, position));
    }

    public goBack(): void {
        this.goTo(this.cursor - 1);
    }

    public goForward(): void {
        this.goTo(this.cursor + 1);
    }

    public atStart(): boolean {
        return this.cursor === 0;
    }

    public atEnd(): boolean {
        return this.cursor === this.items.length - 1;
    }
}
